import React, { useCallback, useEffect, useMemo, useState } from "react"
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button,
    CustomInput
} from 'reactstrap';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { authenticationService } from "services/authentication.service"
import { HistorialPermisosSolicitudes} from "../Solicitud Permisos/TypesSolicitudesPermisos";
import { alertService } from 'components/Varios/alert_service'
import { ObtenerAniosHistorialLicencias, ObtenerAniosHistorialPermisos, ObtenerHistorialLicencias, ObtenerHistorialPermisos } from "./FunctionsHistorialPermisos";
import Cargando from 'components/Varios/Cargando'
import TableHistorialPermisos from "./TablaHistorialPermisos";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { GetDocumentVistaPrevia } from "helpers/files";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import TableHistorialLicencias from "./TablaHistorialLicencias";

type StateHistorial = {
    aniosDisponibles: number[],
    historial: HistorialPermisosSolicitudes[],
    loading: boolean,
    error: boolean,
    anioSeleccionado:number

}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

export default function  HistorialPermisos()
{
    const defaultStateHistorial: StateHistorial = {
        aniosDisponibles: [],
        historial: [],
        loading: false,
        error: false,
        anioSeleccionado:-1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {

        loading: false,
        url: ""
    }

    const [stateHistorialPermisos, setstateHistorialPermisos] = useState<StateHistorial>(defaultStateHistorial)
    const [stateHistorialLicencias, setstateHistorialLicencias] = useState<StateHistorial>(defaultStateHistorial)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    async function ObtenerInformacionAniosHistorialPermisos() {
        setstateHistorialPermisos({ ...stateHistorialPermisos, loading: true })
        const respuesta = await ObtenerAniosHistorialPermisos();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de permisos");
            setstateHistorialPermisos({ ...stateHistorialPermisos, loading: false, error: true })

        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorialPermisos({ ...stateHistorialPermisos, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado})

        }

    }

    async function ObtenerInformacionAniosHistorialLicencias() {
        setstateHistorialLicencias({ ...stateHistorialLicencias, loading: true })
        const respuesta = await ObtenerAniosHistorialLicencias();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de licencias");
            setstateHistorialLicencias({ ...stateHistorialLicencias, loading: false, error: true })

        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorialLicencias({ ...stateHistorialLicencias, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado})

        }

    }


    useEffect(() => {
        ObtenerInformacionAniosHistorialPermisos();
    }, [])

    useEffect(() => {
        ObtenerInformacionAniosHistorialLicencias();
    }, [])

    const GetHistorialPermisosByYear = useCallback(async (anio: number) => {

        setstateHistorialPermisos({ ...stateHistorialPermisos, loading: true })
        const respuesta = await ObtenerHistorialPermisos(anio)
        
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones")
            setstateHistorialPermisos({ ...stateHistorialPermisos, error: true, loading: false })
        }
        else {
            setstateHistorialPermisos({ ...stateHistorialPermisos, historial: respuesta.dataResponse, loading: false , anioSeleccionado:anio})
        }
    }, [stateHistorialPermisos])

    const GetHistorialLicenciasByYear = useCallback(async (anio: number) => {

        setstateHistorialLicencias({ ...stateHistorialLicencias, loading: true })
        const respuesta = await ObtenerHistorialLicencias(anio)
        
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de aprobaciones")
            setstateHistorialLicencias({ ...stateHistorialLicencias, error: true, loading: false })
        }
        else {
            setstateHistorialLicencias({ ...stateHistorialLicencias, historial: respuesta.dataResponse, loading: false , anioSeleccionado:anio})
        }
    }, [stateHistorialLicencias])

    async function ConsultarHistorialPermiso(stateHistorial: StateHistorial) {
        setstateHistorialPermisos({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorialPermisos(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de permisos")
            setstateHistorialPermisos({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorialPermisos({ ...stateHistorial, historial: respuesta.dataResponse, loading: false })
        }

    }

    async function ConsultarHistorialLicencias(stateHistorial: StateHistorial) {
        setstateHistorialLicencias({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorialLicencias(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de permisos")
            setstateHistorialLicencias({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorialLicencias({ ...stateHistorial, historial: respuesta.dataResponse, loading: false })
        }

    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])


    useEffect(() => {
        if (stateHistorialPermisos.aniosDisponibles.length > 0) {
            ConsultarHistorialPermiso(stateHistorialPermisos);
        }
    }, [stateHistorialPermisos.aniosDisponibles])

    useEffect(() => {
        if (stateHistorialLicencias.aniosDisponibles.length > 0) {
            ConsultarHistorialLicencias(stateHistorialLicencias);
        }
    }, [stateHistorialLicencias.aniosDisponibles])

    const tablaHistorialPermisos = useMemo(() => {
        if (stateHistorialPermisos.loading) {
            return <Cargando />
        }
        else if (stateHistorialPermisos.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateHistorialPermisos.error && (stateHistorialPermisos.aniosDisponibles.length === 0 && stateHistorialPermisos.historial.length === 0)) {
            return <div>No hay historial de permisos por mostrar</div>

        }
        else if (!stateHistorialPermisos.loading && stateHistorialPermisos.historial.length > 0) {
            return (
                <TableHistorialPermisos
                    anioSeleccionado={stateHistorialPermisos.anioSeleccionado}
                    dataFilas={stateHistorialPermisos.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio= { (a:number) =>  GetHistorialPermisosByYear(a)}
                
                />
                
            )
        }
    }, [stateHistorialPermisos])

    const tablaHistorialLicencias = useMemo(() => {
        if (stateHistorialLicencias.loading) {
            return <Cargando />
        }
        else if (stateHistorialLicencias.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateHistorialLicencias.error && (stateHistorialLicencias.aniosDisponibles.length === 0 && stateHistorialLicencias.historial.length === 0)) {
            return <div>No hay historial de licencias por mostrar</div>

        }
        else if (!stateHistorialLicencias.loading && stateHistorialLicencias.historial.length > 0) {
            return (
                <TableHistorialLicencias
                    anioSeleccionado={stateHistorialLicencias.anioSeleccionado}
                    dataFilas={stateHistorialLicencias.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio= { (a:number) =>  GetHistorialLicenciasByYear(a)}
                
                />
                
            )
        }
    }, [stateHistorialLicencias])


    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> HISTORIAL SOLICITUDES PERMISOS Y LICENCIAS</div>
            <Tabs defaultActiveKey="permisos">
                <Tab eventKey="permisos" title="Permisos">
                    {tablaHistorialPermisos}
                    
                </Tab>
                <Tab eventKey="licencias" title="Licencias con remuneración">
                    {tablaHistorialLicencias}
                </Tab>
            </Tabs>
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento solicitud'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}


            />

        </div>
    )
}